import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

/**
 * @typedef {Object} Props
 * @property {boolean} open
 * @property {string} userId
 * @property {string} userEmail
 * @property {(userid: string) => void} onSubmit
 * @property {() => void} onCancel
 */

/**
  * @typedef {Object} State
  * @property {string} typedEmail
  */

/**
 * Compute overlap between strings
 * @param {string} expected
 * @param {string} actual
 * @return {number} number of overlapping characters
 */
function computeOverlap(expected, actual) {
  const len = Math.min(expected.length, actual.length);
  for (let i = 0; i < len; i++) {
    if (expected[i] != actual[i]) { return i; }
  }
  return Math.min(expected.length, actual.length);
}

const styles = {
  emailHint: {
    fontFamily: 'monospace',
  },
  emailRemaining: {
    fontWeight: 'bold',
    color: 'rgba(0,0,0,.75)',
  },
};

/**
 * @extends React.Component<Props, State>
 */
class UserDeleteModal extends React.Component {
  /** @type {State} */
  state = {
    typedEmail: '',
  };

  handleOk = (e) => {
    const { userId, onSubmit } = this.props;
    this.setState({ typedEmail: '' });
    onSubmit(userId);
  };

  handleCancel = (e) => {
    const { onCancel } = this.props;
    this.setState({ typedEmail: '' });
    onCancel();
  };

  onMessageChange = e => this.setState({ typedEmail: e.target.value });

  renderEmailHint = () => {
    const { userEmail, classes } = this.props;
    const { typedEmail } = this.state;
    const overlap = computeOverlap(userEmail, typedEmail);
    return (
      <React.Fragment>
        <span className={classes.emailHint}>
          {userEmail.substr(0, overlap)}
          <span className={classes.emailRemaining}>
            {userEmail.substr(overlap)}
          </span>
        </span>
      </React.Fragment>
    );
  }

  render() {
    const { open, userEmail } = this.props;
    const { typedEmail } = this.state;

    return (
      <Dialog
        maxWidth="md"
        fullWidth
        open={open}
        aria-labelledby="confirmation-dialog-title"
        onClose={this.handleCancel}
      >
        <DialogTitle id="confirmation-dialog-title">Delete User</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Type
            {' '}
            {this.renderEmailHint()}
            {' '}
to confirm.
          </DialogContentText>
          <TextField
            autoFocus
            id="filled-textarea"
            placeholder={userEmail}
            fullWidth
            margin="dense"
            value={typedEmail}
            onChange={this.onMessageChange}
            error={!userEmail.startsWith(typedEmail)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} variant="contained" color="secondary">
            Cancel
          </Button>
          <Button
            disabled={userEmail != typedEmail}
            onClick={this.handleOk}
            variant="contained"
            color="primary"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(UserDeleteModal);
